<template>
  <div id="site-header">
    <smartphone-site-header
      v-if="isSmartphone"
      @toggleSmartphoneMenu="$emit('toggleSmartphoneMenu')"
      :smartphoneMenuOpened="smartphoneMenuOpened"
    />
    <desktop-site-header v-else />
  </div>
</template>

<script>
  import SmartphoneSiteHeader from '/src/components/SmartphoneSiteHeader'
  import DesktopSiteHeader from '/src/components/DesktopSiteHeader'

  export default {
    name: 'SiteHeader',
    props: {
      smartphoneMenuOpened: {
        type: Boolean,
        required: true
      }
    },
    components: {
      SmartphoneSiteHeader,
      DesktopSiteHeader
    }
  }
</script>



// WEBPACK FOOTER //
// src/blocks/SiteHeader.vue